import React, { useEffect, useState } from "react";
import style from "../Blog/Blog.module.css";
import { SingleSlider } from "./components/SingleSlider";
import { MultipleSlider } from "./components/MultipleSlider";
import { getArticlesFromApi } from "../../../constants/post";
import { DynamicSlider } from "../DynamicSlider";

export const HomeBlog = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      const data = await getArticlesFromApi();
      const mappedArticles = data.map((item, index) => {
        return {
          id: item.id || item._id || `article_${index + 1}`,
          _id: item._id || item.id || `article_${index + 1}`,
          title: item.title || "",
          description: item.description || "",
          largeDescription: item.content,
          image: item.imagesTitle || item.imageUrl || "",
          content: item.content,
          createdAt: item.createdAt,
        };
      });
      setArticles(mappedArticles);
    };
    fetchArticles();
  }, []);

  return (
    <div className={style.contenedorPrincipal}>
      <DynamicSlider section="Vogue Tips" subSection="Carrusel 1" />
      <p className={style.articulo}>Últimos artículos</p>
      <MultipleSlider articles={articles} />
    </div>
  );
};
